import classNames from 'classnames';
import { type ForwardedRef, forwardRef } from 'react';
import styles from './Card.module.css';
import { CardProps, CommonCardProps } from './types';
const Card = forwardRef(function Card({
  as: Tag = 'div',
  className,
  children,
  size,
  hasShadow = false,
  kind = 'subtle',
  ...props
}: CardProps, ref: ForwardedRef<HTMLElement>) {
  return <Tag {...props as CommonCardProps} className={classNames(styles.container, className, styles[`size-${size}`], {
    [styles.shadow!]: hasShadow,
    [styles.subtle!]: kind === 'subtle',
    [styles.light!]: kind === 'light'
  })}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref={ref as ForwardedRef<any>}>
      {children}
    </Tag>;
});
export default Card;